import { defineComponent as _defineComponent } from 'vue'
import type { Maybe } from '@/helpers/types';
import type { PosterSponsoredRecImages } from '@/interfaces/components/poster/PosterGraphql';

import { computed } from 'vue';
import { useMediaQuery } from '@vueuse/core';
import { BackgroundImageSize } from '@/@types/graphql-types';
import { SingleTitleCampaign } from '@/features/sponsored-recommendations/types';

import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import PictureComp from '@/components/picture/PictureComp.vue';

type ImageObject = { [key in BackgroundImageSize]: string };

export default /*#__PURE__*/_defineComponent({
  __name: 'SponsoredRecommendationImageNewPage',
  props: {
    sponsoredAdCampaign: null,
    lazy: { type: Boolean, default: true },
    additionalContexts: { default: () => [] },
    isCinemaSR: { type: Boolean, default: false },
    showPoster: { type: Boolean, default: false }
  },
  emits: ["onPosterClickOut", "imageError"],
  setup(__props: any) {

const props = __props as { sponsoredAdCampaign: SingleTitleCampaign, lazy: boolean, additionalContexts: SnowplowContext[], isCinemaSR: boolean, showPoster: boolean };





const campaignNode = computed(() => props.sponsoredAdCampaign.node);
const backgroundImages = computed(
	() =>
		props.sponsoredAdCampaign?.backgroundImages?.reduce((imageSizes, options) => {
			if (options?.size) {
				imageSizes[options.size] = options.imageURL;
			}

			return imageSizes;
		}, {} as ImageObject) ?? ({} as ImageObject)
);

// Matches the 704px breakpoint the layout switches on
const useSmallAsset = useMediaQuery('(max-width: 703px)');

const imageSrc = computed(() => {
	if (useSmallAsset.value && backgroundImages.value?.SMALL) {
		return backgroundImages.value.SMALL;
	}
	return props.sponsoredAdCampaign?.promotionalImageUrl ?? '';
});

const imageSrcAvif = computed(() => imageSrc.value.replace(/\.\w+$/, '.avif'));

const posterPath = computed(() => props.sponsoredAdCampaign.node.content.fullPath);

const posterImageOverride = computed<PosterSponsoredRecImages | null>(() => {
	let posterUrl = props.sponsoredAdCampaign?.posterOverride || campaignNode.value.content.posterUrl;
	if (!posterUrl) return null;

	if (posterUrl.startsWith('/')) {
		posterUrl = `${JW_CONFIG.IMAGESCALER_URL}${posterUrl.replace('{profile}', 's332')}`;
	}

	return {
		imageUrl: posterUrl,
		sourceSets: [
			{
				srcSet: posterUrl.replace(/\.{?\w+}?$/, '.avif'),
				imageProp: {
					extension: '.avif',
					type: 'image/avif',
				},
				sourceProp: {
					viewport: 'desktop',
				},
				media: null,
			},
		],
	};
});

return { __sfc: true,props, campaignNode, backgroundImages, useSmallAsset, imageSrc, imageSrcAvif, posterPath, posterImageOverride, PictureComp }
}

})